import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router, ActivatedRoute } from '@angular/router';

declare var $: any,moment : any
@Component({
  selector: 'app-set-change-password',
  templateUrl: './set-change-password.component.html',
  styleUrls: ['./set-change-password.component.scss']
})
export class SetChangePasswordComponent implements OnInit {

  constructor(
    private util: UtilService,
    private apiService: ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  isExistingUser = true

  token = ""

  roleData: any
  returnUrl = ""
  submitted = false
  username = ""
  userId=""
  newPass = ""
  confirmPass = ""
  oldPassword = "";
  isResetSuccess = false
  tmpUsername = ""
  tmpNewPass = ""

  ngOnInit() {

    let cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.username = cookieData["username"]
    this.userId = cookieData["userId"]

    this.roleData = JSON.parse(localStorage.getItem("role"))
    this.returnUrl = localStorage.getItem("returnUrl")
   
    //this.activatedRoute.queryParams.subscribe(params => {
    //  this.token = params['id'];
    //});

    //if(this.token == null || this.token.toString().trim().length == 0){
    //  this.util.ErrorDialog("ไม่พบข้อมูลการขอกำหนดรหัสผ่าน กรุณาลองใหม่อีกครั้ง")
    //}
    //else{
    //  this.validateToken()
    //}

  }

  async validateToken(){
    let req = {
      token_id: this.token
    }
    let res: any = await this.apiService.postCustom("Crm", "GetUsernameFromToken", req)
    if(this.util.isSuccessResponse(res)){
      this.username = res.username
      this.token = res.token_id
      this.isExistingUser = true
    }
    else{
      this.util.ErrorDialog("ไม่พบข้อมูลการขอกำหนดรหัสผ่าน กรุณาลองใหม่อีกครั้ง")
    }
  }

  async changePassword() {
    this.submitted = true
    if (this.newPass.length > 0 && this.newPass == this.confirmPass
      && this.passwordValidation()) {
      this.util.ShowWaiting(true)

      let guidReq: any = {
        username: this.username
      }
      let guidRes: any = await this.apiService.postCustom("Crm", "InsertChangeCallCenterPassToken", guidReq);
      if (this.util.isSuccessResponse(guidRes) && guidRes.token_id != "")
      {
        this.token = guidRes.token_id
      }

      let para = "username=" + this.username
      let user: any = await this.apiService.get("crmservice", "callcenterProfile", para)

      if (user != null && user.length > 0) {
        if (user[0].dpa_customwebuserid != null && user[0].dpa_customwebuserid.toString().trim().length != 0) {
          let guidReq: any = {
            dpa_customwebuserid: user[0].dpa_customwebuserid,
            guid: this.token
          }
          this.oldPassword = user[0].dpa_password;
          
          if (this.oldPassword == this.newPass) {
            this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ password ต้องไม่เท่ากับ password เดิม")
          } else {

            let guidRes: any = await this.apiService.post("crmservice", "updateCallcenterGuid", guidReq);
            if (this.util.isSuccessResponse(guidRes) && guidRes.RESMSG == "SUCCESS") {
              let req: any = {
                //username: this.username,
                newPassword: this.newPass,
                //forcechangepassword: true,
                guid: this.token
              }

              var res: any = await this.apiService.put("crmservice", "callcenterChangepassword/" + this.username, req);
              if (this.util.isSuccessResponse(res) && res.RESMSG == "SUCCESS") {
                this.isResetSuccess = true
                this.tmpUsername = this.username
                this.tmpNewPass= this.newPass
                this.clear()
                this.username = ""
                
                this.util.ShowWaiting(false)
                this.util.SuccessDialog("เปลี่ยน Password สำเร็จ")
                let thisTs = this
                $('#btnSuccessOK').on('click', function () {
                  if(thisTs.roleData.dpa_tab_poolcase){
                    thisTs.router.navigate(["/mainmenu/pool"])
                  }
                  else if(thisTs.roleData.dpa_tab_allcase){
                    thisTs.router.navigate(["/mainmenu/shared"])
                  }
                  else if(thisTs.roleData.dpa_tab_case){
                    thisTs.router.navigate(["/mainmenu/case"])
                  }
                  else if(thisTs.roleData.dpa_tab_contact){
                    thisTs.router.navigate(["/mainmenu/contact"])
                  }
                  else if(thisTs.roleData.dpa_tab_chatbot){
                    thisTs.router.navigate(["/mainmenu/chatbot"])
                  }
                  else if(thisTs.roleData.dpa_tab_socialmonitoring){
                    thisTs.router.navigate(["/mainmenu/socialMedia"])
                  }
                  else if(thisTs.roleData.dpa_tab_km){
                    thisTs.router.navigate(["/mainmenu/knowledge"])
                  }
                  else if(thisTs.roleData.dpa_tab_report){
                    thisTs.router.navigate(["/mainmenu/report"])
                  }
                  else{
                    thisTs.router.navigate(["/mainmenu"])
                    thisTs.util.WarningDialog("คุณไม่มีสิทธิ์เข้าใช้เมนู")
                  }
                  //thisTs.router.navigate(['login'], { queryParams: { user: thisTs.tmpUsername, pass: thisTs.tmpNewPass } });
                });

               
                //this.DeleteToken(this.token);
                //this.router.navigate(['login']);
              }
              else {
                this.util.ShowWaiting(false)
                this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ")
              }
            }
            else {
              this.util.ShowWaiting(false)
              this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ")
            }
          }
          
        }
      }else{
        
        this.util.ShowWaiting(false)
      }
    }
  }

  clear() {
    this.submitted = false
    this.newPass = ""
    this.confirmPass = ""
  }

  close() {
    window.close()
  }

  passwordValidation() {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(this.newPass)
  }

  DeleteToken(TokenID: any) {
    let ParamObj: any = {
      token_id: TokenID
    };
    this.apiService.postCustom("user", "deletetoken", ParamObj);
  }
}



// WEBPACK FOOTER //
// ./src/app/set-change-password/set-change-password.component.ts